import { render, staticRenderFns } from "./MultiStepForm.vue?vue&type=template&id=bb08bb14"
import script from "./MultiStepForm.vue?vue&type=script&lang=ts"
export * from "./MultiStepForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports